import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import moment from 'moment';
import util from '@util';
import { queryBudgetAccount } from '@api/finance/budget';
import { Col, Divider, Icon, message, Modal, Row, Table, Tooltip } from 'antd';
import { getAdjustData } from '@store/modules/finance/budget/adjust_data';
import { queryDictExpend } from '@api/core/dict';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expendType: [],
      accountList1: [],
      accountList2: [],
      accountFlag: false,
      year: '',
    };
  }

  componentDidMount() {
    const currentYear = this.props.year || moment.unix(new Date().getTime() / 1000).format('YYYY');
    this.loadExpendType();
    this.setState({
      year: currentYear,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      year: nextProps.year,
    });
  }

  // 根据年份判断（预算调整）
  accordYear = () => {
    const currentYear = +this.state.year;
    const year = +(this.props.year ? this.props.year : this.state.year);
    let adjustFlag = true;
    if (year < currentYear) {
      adjustFlag = false;
    } else {
      adjustFlag = true;
    }

    return adjustFlag;
  };

  // 预算调整数据生成
  setAdjustGroup = id => {
    const { company } = this.props;
    company.map(item => {
      if (item.uuid === id) {
        this.props.dispatch(getAdjustData(item));
      } else if (item.children && item.children.length > 0) {
        item.children.map(item1 => {
          if (item1.uuid === id) {
            this.props.dispatch(getAdjustData(item1));
          }
          return 1;
        });
      }

      return 1;
    });
  };

  initTitle = () => {
    const content = '本年预算(调整次数，调整总金额)';
    return (
      <span>
        本年预算
        <Tooltip title={content}>
          <Icon type="info-circle" style={{ fontSize: '10px' }} />
        </Tooltip>
      </span>
    );
  };

  currentTitle = () => {
    const content = '预算余额(冻结金额)';
    return (
      <span>
        预算余额
        <Tooltip title={content}>
          <Icon type="info-circle" style={{ fontSize: '10px' }} />
        </Tooltip>
      </span>
    );
  };

  // 获取支出类别
  loadExpendType = () => {
    queryDictExpend().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          expendType: res.data,
        });
      }
    });
  };

  // 获取余额明细
  getAccount = uuid => {
    const { expendType } = this.state;
    queryBudgetAccount({
      groupUuid: uuid,
      year: this.state.year,
    }).then(res => {
      if (res.statusCode === 200) {
        res.data.map(item => {
          expendType.map(it => {
            if (item.type === it.value) {
              item.typeName = it.key;
            }
            return it;
          });
          return item;
        });
        this.setState({
          accountList1: res.data.slice(0, 15),
          accountList2: res.data.slice(15),
          accountFlag: true,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  handleCancel = () => {
    this.setState({
      accountFlag: false,
    });
  };

  columns = () => {
    return [
      {
        title: '序号',
        dataIndex: 'num',
        key: 'num',
        width: '6%',
        render: (text, record, index) => {
          return <span>{index + 1}</span>;
        },
      },
      {
        title: '预算组名称',
        dataIndex: 'name',
        key: 'name',
        width: '12%',
        align: 'left',
        render: (text, record) => {
          if (record.isEnable === 0) {
            return <span>{text}</span>;
          }
          if (record.isEnable === 1) {
            return <Link to={`/finance/budget/${record.uuid}/check`}>{text}</Link>;
          }
        },
      },
      {
        title: this.initTitle(),
        dataIndex: 'init',
        key: 'init',
        width: '16%',
        align: 'left',
        render: (text, record) => {
          const money = util.numberFormat(text, 2, '.', ',');

          return (
            <span>
              {money === '0.00' ? '-' : money}
              {record.adjustmentCount ? (
                <span style={{ color: '#FF9F9F' }}>
                  <span style={{ color: '#505659' }}>{'( '}</span>
                  {record.adjustmentCount}:{record.adjustmentSum}
                  <span style={{ color: '#505659' }}>{' )'}</span>
                </span>
              ) : (
                ''
              )}
            </span>
          );
        },
      },
      {
        title: this.currentTitle(),
        dataIndex: 'current',
        key: 'current',
        width: '16%',
        align: 'left',
        render: (text, record) => {
          const money = util.numberFormat(text, 2, '.', ',');
          return (
            <div>
              {money === '0.00' ? (
                '-'
              ) : (
                <Link onClick={() => this.getAccount(record.uuid)}>{money}</Link>
              )}
              {record.freeze ? (
                <span style={{ color: '#BCBCBC' }}>
                  <span style={{ color: '#505659' }}>{'( '}</span>
                  冻结{record.freeze}
                  <span style={{ color: '#505659' }}>{' )'}</span>
                </span>
              ) : (
                ''
              )}
            </div>
          );
        },
      },
      {
        title: '本年目标收入',
        dataIndex: 'aims',
        key: 'aims',
        width: '12%',
        align: 'left',
        render: text => {
          const money = util.numberFormat(text, 2, '.', ',');
          return <span>{money === '0.00' ? '-' : money}</span>;
        },
      },
      {
        title: '实际收入',
        dataIndex: 'income',
        key: 'income',
        width: '12%',
        align: 'left',
        render: text => {
          const money = util.numberFormat(text, 2, '.', ',');
          return <span>{money === '0.00' ? '-' : money}</span>;
        },
      },
      {
        title: '操作',
        key: 'done',
        width: '26%',
        render: (text, record) => {
          const year = +(this.props.year ? this.props.year : this.state.year);

          return (
            <span>
              <span>
                {this.accordYear() ? (
                  <Link
                    onClick={() => this.setAdjustGroup(record.uuid)}
                    to={`/finance/budget/${'initiate'}/${year}/adjust`}
                  >
                    调整预算
                  </Link>
                ) : null}
                {this.accordYear() ? <Divider type="vertical" /> : null}
                <Link
                  to={{
                    pathname: `/finance/budget/${record.uuid}/toviewDetail`,
                    query: {
                      groupName: record.name,
                      year: this.props.year,
                    },
                  }}
                >
                  查看预算
                </Link>
                <Divider type="vertical" />
                <Link to={`/finance/budget/${record.uuid}/${year}/balance`}>收支分析</Link>
              </span>
            </span>
          );
        },
      },
    ];
  };

  accountColumns = () => {
    return [
      {
        title: '类目',
        dataIndex: 'typeName',
        key: 'typeName',
        width: '6%',
        render: text => {
          return text;
        },
      },
      {
        title: '余额',
        dataIndex: 'current',
        key: 'current',
        width: '6%',
        render: text => {
          const current = util.numberFormat(text);
          return text ? current : text;
        },
      },
      {
        title: '冻结金额',
        dataIndex: 'freeze',
        key: 'freeze',
        width: '6%',
        render: text => {
          const freeze = util.numberFormat(text);
          return text ? freeze : text;
        },
      },
    ];
  };

  onSelectChange = selectedRowKeys => {
    let selected = [];
    if (selectedRowKeys.length > 1) {
      selected.push(selectedRowKeys[1]);
    } else {
      selected = selected.concat(selectedRowKeys);
    }
    this.props.handleAdd(selected[0]);
  };

  render() {
    const { company, isLoading } = this.props;
    const { accountList1, accountList2 } = this.state;
    let sp = 24;
    if (accountList2 && accountList2.length > 0) {
      sp = 11;
    }
    return (
      <div>
        <Table
          rowKey={record => record.uuid}
          columns={this.columns()}
          dataSource={company}
          pagination={false}
          loading={isLoading}
          size="small"
        />
        <Modal
          title={<span>{`预算余额  年份：${this.state.year}`}</span>}
          footer={null}
          onCancel={this.handleCancel}
          visible={this.state.accountFlag}
          width="60%"
        >
          <Row>
            <Col span={sp}>
              <Table dataSource={accountList1} columns={this.accountColumns()} pagination={false} />
            </Col>
            {accountList2 && accountList2.length > 0 ? <Col span={2} /> : null}
            {accountList2 && accountList2.length > 0 ? (
              <Col span={11}>
                <Table
                  dataSource={accountList2}
                  columns={this.accountColumns()}
                  pagination={false}
                />
              </Col>
            ) : null}
          </Row>
        </Modal>
      </div>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/finance/budget/org/TableOrg.js